<template>
  <el-dialog
    :title="payTitle"
    :close-on-click-modal="false"
    :visible.sync="visible"
    @close="closeDialog"
    width="960px"
    :class="'pay-dialog'"
    :destroy-on-close="true"
  >
    <div class="qrcode-way">
      <div class="mpay-qrcode-container">
        <!-- <div ref="qrcodeContainer" class="qrcode-container"></div> -->
        <form id="payment-form">
          <!-- 初始化paypal的输入框 -->
          <div
            id="paypal-button-container"
            v-show="this.payType != 'wechat'"
          ></div>
          <!-- 初始化payment的输入框 -->
          <div v-show="this.payType == 'wechat'">
            <div id="payment-element" class="payment-element"></div>
            <button id="submit">
              <span id="button-text">pay</span>
            </button>
            <div id="payment-message" class="hidden"></div>
          </div>
        </form>
      </div>
      <div class="mpay-qrcode-tips">
      
        <p class="pay-info-container">
          Reload:RM{{ showPrice }}
          <span v-if="nowPreferential > 0">[Free RM{{ nowPreferential }}]</span>
        </p>
        <p class="qr-tip-wx" v-if="payType != 'wechat'">
          Paypal fee: 3.9% + RM2 fixed fee
        </p>
        <p class="qr-tip-wx" v-else>
          Processing fee: 3.0% + RM1 fixed fee
        </p>
        <p class="pay-info-container">
          Total payment: <span class="need-to-pay"> RM{{ currentPrice }} </span>
        </p>
        <countdown
          v-on:end_callback="CountTimeOver"
          v-if="this.info.isFlag"
          :currentTime="Number(info.currentTime)"
          :startTime="Number(info.startDate)"
          :endTime="Number(info.endDate)"
          :tipText="'订单支付开始计时'"
          :tipTextEnd="'订单支付结束计时'"
          :endText="'订单已超时，请重新生成'"
          :minutesTxt="'min'"
          :secondsTxt="'sec'"
        ></countdown>
        <div class="warning">
          <p>
            Warn: Please do not refresh the page or close the payment window
            when making payment.
          </p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  getPayERCode,
  getPayZFBERCode,
  queryPayStatus,
  queryPayStatusNew,
  updatePayStatus,
  HPJCharge,
  queryPayStatusZFB,
} from "../../../api/pay";
import { initialize, checkStatus, initLinsten } from "@/utils/checkout";
import { getToken } from "@/utils/storage";
import { paypalReadyPay, paypalCapture } from "../../../api/pay";
import { paySuccess } from "../../../api/charge";
import QRCode from "qrcodejs2";
import { message } from "@/utils/resetMessage";
import countdown from "@/components/tempcount/countdown.vue";
export default {
  components: {
    countdown,
  },
  props: [
    "dialogVisible",
    "curPreferential",
    "currentPrice",
    "dialogPaying",
    "currentPayType",
    "currentCouponId",
    "showPrice",
  ],
  watch: {
    dialogVisible: {
      handler(val) {
        this.visible = val;
        this.$nextTick().then(() => {
          if (val && !this.dialogPaying) this.initPay();
        });
      },
      deep: true,
    },
    curPreferential(newValue) {
      if (!this.dialogPaying) {
        this.nowPreferential = newValue;
      }
    },
    currentPrice(newValue) {
      if (!this.dialogPaying) {
        this.nowprice = newValue;
      }
    },
    showPrice(newValue) {
      if (!this.dialogPaying) {
        this.nowprice = newValue;
      }
    },
    currentPayType(newValue) {
      if (!this.dialogPaying) {
        this.payType = newValue;
        if (this.payType == "wechat") {
          this.payName = "stripe";
          this.payTitle = "Stripe Reload";
        } else {
          this.payName = "BTC";
          this.payTitle = "Paypal Reload";
        }
      }
    },
    currentCouponId(newValue) {
      if (!this.dialogPaying) {
        this.nowCouponId = newValue;
      }
    },
  },
  data() {
    return {
      visible: false,
      feeprice: this.showPrice,
      nowprice: this.currentPrice,
      nowPreferential: this.curPreferential,
      nowCouponId: this.currentCouponId,
      erCode: null,
      payType: "wechat",
      payName: "stripe",
      payTitle: "stripe",
      info: {
        isFlag: false,
        currentTime: "",
        startDate: "",
        endDate: "",
      },
      currentOrderId: "", //当前订单ID
      isPaying: false, //是否正在支付
      timer: "", // 定时任务
    };
  },
  methods: {
    //初始化支付
    initPay() {
      console.log(this.payType);
      if (this.payType == "wechat") {
        //stripe
        let dataForm = {
          order_type: this.payType,
          order_price: this.currentPrice,
          other_price: this.curPreferential,
        };
        initialize(dataForm);
        initLinsten();
      } else {
        //paypal
        console.log(this.currentPrice);
        this.initPayPal();
      }
    },
    initPayPal() {
      //初始化paypal
      paypal
        .Buttons({
          createOrder: () => {
            return fetch(window.baseUrl + "/api/pay/paypalReadyPay", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                Authorization: getToken(),
              },
              body: JSON.stringify({
                order_price: this.currentPrice,
              }),
            })
              .then((res) => {
                return res.json();
              })
              .then((data) => {
                return data.id;
              });
          },
          onApprove: (data) => {
            return fetch(window.baseUrl + "/api/pay/paypalCapture", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                Authorization: getToken(),
              },
              body: JSON.stringify({
                orderId: data.orderID,
              }),
            })
              .then((res) => {
                return res.json();
              })
              .then((details) => {
                message.success({
                  message: "success",
                  duration: 4000,
                  offset: 80,
                });
                //this.getUserList();
                //this.getTableData();
                this.closeDialog();
              });
          },
        })
        .render("#paypal-button-container"); // Display payment options on your web page

      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "UA-78962210-9");
    },

    getPayStatusZFB() {
      //支付宝查询状态
      if (this.currentOrderId != null && this.currentOrderId != "") {
        this.timer = setTimeout(() => {
          let data1 = {
            orderId: this.currentOrderId,
          };
          queryPayStatusZFB(data1)
            .then((result) => {
              if (result.payStatus == 1) {
                //支付成功
                //支付成功后需要加状态
                if (!this.isPaying) {
                  this.isPaying = true;
                  this.doPaySuccess(); //和支付宝公用
                }
              } else if (result.payStatus == 3) {
                //过期
                this.doUpdatePayStatus();
                this.$emit("onPay", false); // 创建订单的状态
              } else {
                //继续查询
                this.getPayStatusZFB();
              }
            })
            .catch((error) => {
              this.getPayStatusZFB();
            });
        }, 3000);
      }
    },
    doUpdatePayStatus() {
      //更新订单状态
      if (this.currentOrderId != null && this.currentOrderId != "") {
        let data2 = {
          orderId: this.currentOrderId,
          status: 3,
        };
        updatePayStatus(data2)
          .then((result) => {
            console.log(JSON.stringify(result));
            this.$emit("closeDialog");
          })
          .catch((error) => {
            console.log(JSON.stringify(error));
          });
      }
    },
    doUpdatePayStatus_close() {
      //更新订单状态
    },

    closeDialog() {
      this.$emit("onPay", false); // 创建订单的状态
      this.$emit("closeDialog");
    },
    CountTimeOver() {
      //倒计时结束触发
      this.$emit("onPay", false); // 创建订单的状态
      this.doUpdatePayStatus_close();
    },
  },
};
</script>

<style lang="scss" scoped>
.font-orange {
  font-size: 26px;
  color: #ffae00;
}
.qrcode-way {
  display: flex;
  height: fit-content;
  align-items: center;
  margin-left: 20px;
  .mpay-qrcode-container {
    position: relative;
    width: 960px;
    height: fit-content;
    padding: 5px;
    text-align: center;
    .paypal_css {
      position: absolute;
      width: 100%;
      height: auto;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .qrcode-container {
    width: 100%;
    height: 92%;
    position: relative;
  }
  .mpay-qrcode-tips {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
  }
  .pay-info-container {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333;
    .need-to-pay {
      font-size: 24px;
      color: #fa2323;
      font-weight: 700;
      margin: 0 8px 0 2px;
    }

    .need-to-pay1 {
      font-size: 20px;
      color: #fa2323;
      font-weight: 300;
      margin: 0 8px 0 2px;
    }
  }
  .qr-tip-zfb {
    font-size: 16px;
    color: #0c9ee0;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .qr-tip-wx {
    font-size: 16px;
    color: #3cb73f;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .warning {
    display: block;
    padding: 8px 16px;
    background-color: #fff6f7;
    border-radius: 4px;
    border-left: 5px solid #fe6c6f;
    margin: 20px 0;
    p {
      font-size: 14px;
      color: #5e6d82;
      line-height: 1.5em;
    }
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  ::v-deep .pay-dialog {
    width: 90% !important;
    max-width: 90% !important;
  }

  ::v-deep .pay-dialog .el-dialog__body {
    padding: 10px;
  }

  .qrcode-way {
    flex-direction: column;
    margin-left: 0;
    align-items: stretch;

    .mpay-qrcode-container {
      width: 100%;
      padding: 10px 0;
    }

    .mpay-qrcode-tips {
      margin-left: 0;
      margin-top: 20px;
      align-items: center;
    }

    .pay-info-container {
      justify-content: center;
    }
  }
}
</style>
